import React from 'react';
import { Badge } from '../ui/badge';
import GoogleReviews from '../GoogleReviews';

const Reviews = () => {
  return (
    <section id="reviews" className="py-20 px-4 bg-zinc-900" data-testid="reviews-section">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <Badge className="bg-amber-500 text-black mb-4 px-4 py-1 text-sm">RECENSIONI</Badge>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4">
            Cosa dicono <span className="text-amber-500">i nostri clienti</span>
          </h2>
        </div>

        <GoogleReviews />
      </div>
    </section>
  );
};

export default Reviews;
